import { cn } from "@app/lib/utils";
import { linksDrawerAtom } from "@design-system/atoms";
import { Link } from "@design-system/components";
import { headerLinks, linksDrawerBottom } from "@design-system/data";
import { trans } from "@mongez/localization";
import React from "react";

export function LinksDrawer() {
  const opened = linksDrawerAtom.useOpened();

  return (
    <div
      className={cn(
        "z-60 bg-cinder absolute start-0 grid w-full grid-rows-[0fr] bg-white transition-all duration-500",
        opened && "grid-rows-[1fr]",
      )}
    >
      <div
        className={cn(
          "text-b overflow-hidden transition-all",
          opened && "h-dvh overflow-auto py-8",
        )}
      >
        <div className="mx-auto w-[80%]">
          <div className="grid grid-cols-4">
            {headerLinks.map((item, index) => (
              <React.Fragment key={index}>
                {item.children && (
                  <div className="flex flex-col gap-6">
                    <h4 className="border-s-4 border-bright-orange ps-3 text-xl font-semibold text-dark-blue">
                      {trans(item.title)}
                    </h4>
                    <div className="flex flex-col gap-4">
                      {item.children.map((link, index) =>
                        link.children ? (
                          <div key={index} className="flex flex-col gap-3">
                            <span className="w-fit font-semibold text-dark-blue text-opacity-80">
                              {trans(link.title)}
                            </span>
                            <div className="flex flex-col gap-3 ps-4">
                              {link.children.map((child, childIndex) => (
                                <Link
                                  key={childIndex}
                                  to={child.href}
                                  onClick={linksDrawerAtom.close}
                                  className="w-fit text-sm text-dark-blue text-opacity-60 transition-colors duration-300 hover:text-secondary hover:underline"
                                >
                                  {trans(child.title)}
                                </Link>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <Link
                            key={index}
                            to={link.href}
                            onClick={linksDrawerAtom.close}
                            className="w-fit text-dark-blue text-opacity-70 transition-colors duration-300 hover:text-secondary hover:underline"
                          >
                            {trans(link.title)}
                          </Link>
                        ),
                      )}
                    </div>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
          <hr className="my-10 border-dark-blue border-opacity-10" />
          <div className="grid grid-cols-4">
            {linksDrawerBottom.map((link, index) => (
              <Link
                to={link.href}
                onClick={linksDrawerAtom.close}
                key={index}
                className="border-s-4 border-bright-orange ps-3 text-xl font-semibold text-dark-blue"
              >
                {trans(link.title)}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
